/**
 * Converts a File object to a Base64 string.
 * @param file The file to convert
 * @returns A promise that resolves to the Base64 string
 */
export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

/**
 * Validates the file size and type.
 * @param file The file to validate
 * @param maxSizeInMB Maximum allowed size in MB
 * @param allowedTypes Array of allowed MIME types
 */
export const validateImage = (
  file: File,
  maxSizeInMB: number = 0.8,
  allowedTypes: string[] = ['image/jpeg', 'image/png', 'image/webp']
) => {
  if (!allowedTypes.includes(file.type)) {
    throw new Error(`Invalid file type. Allowed types: ${allowedTypes.join(', ')}`);
  }
  if (file.size > maxSizeInMB * 1024 * 1024) {
    throw new Error(`File too large. Maximum size: ${maxSizeInMB}MB`);
  }
};
